import { ResponseInterface } from "../interfaces";
import { EventTrackingDto } from "../interfaces/Dtos/EventTrackingDTO";
import { TrackingRequestDto } from "../interfaces/Dtos/TrackingRequestDTO";
import api from "./api";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_HOST;

export const getEventTrackingList = async (
  trackingRequest: TrackingRequestDto[],
  applicationID: number,
): Promise<ResponseInterface<EventTrackingDto[]>> => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/Tracking/GetEventTrackingList?ApplicationID=${applicationID}`;
  const body = JSON.stringify(trackingRequest);

  try {
    const response = await api.post(uri, body, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching event tracking list:", error);
  }

  return {
    message: "Error fetching event tracking list",
    didError: true,
    errorMessage: "Error fetching event tracking list",
    model: null,
  };
};
